import React, { useState } from "react";
import { Table, Row, Col, Button, Space, message } from "antd";
import { removeDisqualifiedSubcontractors } from "../../../../../services/vendorProfile.services";
import SCDisqualificationsModal from "./SCDisqualificationsModal";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { DisqualifiedSubContractorColumns } from "../../../../PQQ/tableColumns";

const SCDisqualifications = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchDisqualifiedSubcontractors();
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeDisqualifiedSubcontractors({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...DisqualifiedSubContractorColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Subcontractor
        </Button>
        <Table
          size="small"
          columns={columns}
          dataSource={props.disqualifiedSubcontractorsData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>

      {visible && (
        <SCDisqualificationsModal
          setVisible={setVisible}
          title="Add Subcontractor"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default SCDisqualifications;
